import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";

import type { AccountLimits } from "../types";

async function getAccountLimits(
  workspaceId: string,
  accountId: string,
): Promise<AccountLimits> {
  const {
    limit: { connect, inmail, warmup },
  } = await get(`workspaces/${workspaceId}/accounts/${accountId}/limits`);

  //the server returns a bunch of extra data we don't need
  return { connect, inmail, warmup };
}

export default function useAccountLimits(accountId: string) {
  const { id: workspaceId } = useSelectedWorkspaceContext();

  const { data: accountLimits, isLoading: isLoadingAccountLimits } = useQuery({
    queryKey: getQueryKeys(workspaceId).accountsKeys.limits(accountId),
    queryFn: () => getAccountLimits(workspaceId, accountId),
    refetchOnMount: false,
  });

  return {
    accountLimits,
    isLoadingAccountLimits,
  };
}
